export default "__VITE_ASSET__RVS_ciEg__"